import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const TeamListPage = () =>
  import('@modules/team/components/team-list-page.vue');
const TeamFormPage = () =>
  import('@modules/team/components/team-form-page.vue');
const TeamViewPage = () =>
  import('@modules/team/components/team-view-page.vue');
const TeamImporterPage = () =>
  import('@modules/team/components/team-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'team',
        path: '/team',
        component: TeamListPage,
        meta: {
          auth: true,
          permission: Permissions.values.teamView,
        },
      },
      {
        name: 'teamNew',
        path: '/team/new',
        component: TeamFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.teamCreate,
        },
      },
      {
        name: 'teamImporter',
        path: '/team/import',
        component: TeamImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.teamImport,
        },
      },
      {
        name: 'teamEdit',
        path: '/team/:id/edit',
        component: TeamFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.teamEdit,
        },
        props: true,
      },
      {
        name: 'teamView',
        path: '/team/:id',
        component: TeamViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.teamView,
        },
        props: true,
      },
    ],
  },
];
